var progressIndicatorI18n = {
  loading: 'Loading'
};
export default progressIndicatorI18n;